import { RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { Profile } from "../data/profile";
import type { OpenProfileOverlay } from "../overlays/profileOverlay";
import {
    MissingRow,
    PreferenceGroup,
    ProfileParagraph,
    ProfileSection,
} from "../profilePrimitives";
import { listMissingLabels } from "../profileUtils";

export function OnboardingSection({
    onboarding,
    setOverlay,
}: {
    onboarding: Profile["onboarding"];
    setOverlay: OpenProfileOverlay;
}) {
    return (
        <ProfileSection title="Onboarding">
            {onboarding.completedVia === "phone" ? (
                <>
                    <ProfileParagraph>
                        This member was onboarded over the phone
                    </ProfileParagraph>
                    {!onboarding.hasLoggedIn && (
                        <Button
                            variant="ghost"
                            size="xs"
                            className="self-start"
                            onClick={() =>
                                setOverlay({
                                    type: "onboarding-by-phone",
                                    enable: false,
                                })
                            }
                        >
                            <RotateCcw data-icon="inline-start" />
                            Change back to app
                        </Button>
                    )}
                </>
            ) : (
                onboarding.summary && (
                    <ProfileParagraph>{onboarding.summary}</ProfileParagraph>
                )
            )}
            <MissingRow
                labels={listMissingLabels([
                    {
                        label: "Top benefits",
                        present: !!onboarding.benefits?.length,
                    },
                    {
                        label: "Recommendations",
                        present: !!onboarding.proactivity?.length,
                    },
                ])}
            />
            {onboarding.benefits && (
                <PreferenceGroup title="Top benefits" items={onboarding.benefits} />
            )}
            {onboarding.proactivity && (
                <PreferenceGroup
                    title="Proactivity preferences"
                    items={onboarding.proactivity}
                />
            )}
            {!onboarding.completedVia && (
                <Button
                    variant="secondary"
                    onClick={() =>
                        setOverlay({
                            type: "onboarding-by-phone",
                            enable: true,
                        })
                    }
                >
                    Complete by phone
                </Button>
            )}
        </ProfileSection>
    );
}
